'use client'
import { ButtonRoundStyle, Form, PopupWrapper, RHFTextField } from '@/components'
import yup from '@/utils/yup-global'
import { trackingOrderSchema } from '@/validations'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material'
import { usePathname, useRouter } from 'next/navigation'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

const description = {
  title: 'dialog-title-lookup-order',
  description: 'dialog-description-lookup-order',
  confirmText: 'XÁC NHẬN',
  cancelText: 'HỦY BỎ',
}

interface PopupFormOrderLookupProps {
  isMobile?: boolean
  isDesktop?: boolean
  style?: React.CSSProperties
}

export const PopupFormOrderLookup = ({ isMobile, isDesktop, style }: PopupFormOrderLookupProps) => {
  const router = useRouter()
  const [open, setOpen] = useState(false)
  const pathname = usePathname()
  const method = useForm<yup.InferType<typeof trackingOrderSchema>>({
    resolver: yupResolver(trackingOrderSchema),
  })
  const { handleSubmit, reset } = method

  const onSubmit = (data: yup.InferType<typeof trackingOrderSchema>) => {
    router.push(`/order-lookup?order_code=${data.orderId}&email_or_phone=${data.emailOrPhone}`)
    handleClose()
    reset()
  }
  const handleClose = () => {
    setOpen(false)
  }
  const handleOpen = () => {
    router.prefetch('/order-lookup')
    setOpen(true)
  }
  const isShowOrderLookup = pathname !== '/order-lookup'
  return (
    <>
      {isShowOrderLookup && (
        <Button
          onClick={handleOpen}
          variant="contained"
          sx={{
            py: 1,
            boxShadow: 'none',
            display: { xs: isMobile ? 'flex' : 'none', lg: isDesktop ? 'flex' : 'none' },
            ...style,
          }}
        >
          TRA CỨU ĐƠN HÀNG
        </Button>
      )}
      <PopupWrapper isOpen={open} width="494px" maxHeight="85vh" handleClose={handleClose}>
        <DialogTitle
          id={description.title}
          sx={{
            textAlign: 'center',
            gap: 2,
            fontWeight: 600,
            p: 0,
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            mb: 1,
          }}
        >
          TRA CỨU ĐƠN HÀNG
        </DialogTitle>

        {/* Nội dung mô tả */}
        <DialogContent
          sx={{
            p: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            overflow: 'visible',
          }}
        >
          <DialogContentText
            id={description.description}
            sx={{
              color: 'primary.main',
            }}
          >
            <Typography variant="body2" textAlign={'center'}>
              Để biết thông tin về đơn hàng của bạn.
            </Typography>
            <Typography variant="body2" textAlign={'center'} fontWeight={600}>
              Vui lòng nhập mã đơn hàng của bạn để chúng tôi hỗ trợ nhé!
            </Typography>
          </DialogContentText>
          <Form methods={method} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2}>
              <RHFTextField required name="orderId" label={'Mã đơn hàng:'} placeholder={'Nhập mã đơn hàng'} />
              <RHFTextField
                required
                name="emailOrPhone"
                label={'Số điện thoại/e-mail:'}
                placeholder={'Nhập số điện thoại hoặc e-mail'}
              />
              <ButtonRoundStyle
                variant="contained"
                type="submit"
                sx={{
                  fontSize: {
                    xs: '0.875rem',
                    md: '1rem',
                  },
                  transition: 'all .3s ease-in-out',
                  color: 'primary.contrastText',
                  boxShadow: 'none',
                  borderColor: 'primary.main',
                  border: '1px solid',
                  height: '44px',
                  '&:hover': {
                    backgroundColor: 'primary.contrastText',
                    color: 'primary.main',
                    boxShadow: 'none',
                  },
                }}
              >
                TRA CỨU ĐƠN HÀNG
              </ButtonRoundStyle>
            </Stack>
          </Form>
        </DialogContent>
      </PopupWrapper>
    </>
  )
}
